import React, { useContext } from 'react'
import MyAccountWelcomeTitleUI from '@interflora/ui-components/build/components/MyAccountWelcomeTitle/MyAccountWelcomeTitle'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import { useRouter } from 'next/router'
import { useLoaded } from '@interflora/ui-components'

const MyAccountWelcomeTitle = (props: object) => {
  const { getCustomer } = useContext(SiteContext)
  const router = useRouter()
  const { success } = router.query || {}
  const isLoading = getCustomer.loading
  useLoaded(props, !isLoading)

  if (isLoading) {
    return <h1>Loading</h1>
  }

  if (!isLoading && !getCustomer?.data?.customer?.id) {
    router.replace('/sign-in')
  }

  const { customer } = getCustomer.data
  return <MyAccountWelcomeTitleUI customer={customer} success={success?.toString()} key={success?.toString()} />
}

export default MyAccountWelcomeTitle
